import { PaymentFormValues } from '@src/types/packages';
import { PurchaseResetPackage } from '@src/types/purchaseReset';
import { FC } from 'react';
import { CheckoutDialog } from '@src/features/user/checkout/CheckoutDialog';

interface PurchaseResetDialogProps {
  open: boolean;
  resetPackage: PurchaseResetPackage | null;
  loading?: boolean;
  submitting?: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: PaymentFormValues) => Promise<void> | void;
}

export const PurchaseResetDialog: FC<PurchaseResetDialogProps> = ({
  open,
  resetPackage,
  loading,
  submitting,
  onOpenChange,
  onSubmit,
}) => {
  return (
    <CheckoutDialog
      loading={loading}
      open={open}
      package={resetPackage}
      packageDisplayName={resetPackage?.display_name_web ?? 'Purchase Reset'}
      submitting={submitting}
      title="Purchase Reset"
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
};
